const basicOperationsDurationInSecs = 150;
const basicEpochDurationInSecs = 1.155;
const epochDurationPerDatasetSecond = 0.016;

export const calculateEtaInMins = (
  datasetSeconds: number,
  datasetFilesCount: number,
  epochs: number,
) => {
  return Math.ceil(
    (datasetFilesCount * basicOperationsDurationInSecs +
      epochs *
        (basicEpochDurationInSecs +
          datasetSeconds * epochDurationPerDatasetSecond)) /
      60,
  );
};
